import React from 'react';
import { P } from '@fashionnovateam/nova-ui-toolkit';
import { ItemLeadTime } from './types';
import { BulkApplyPopover } from './BulkApplyPopover';
import { SubmitAllPopover } from './SubmitAllDialog';

type BulkActionToolbarProps = {
  selectedCount: number;
  countrySelectItems: { value: string; label: string; disabled?: boolean }[];
  onBulkApply: (
    field: keyof ItemLeadTime,
    value: ItemLeadTime[keyof ItemLeadTime],
  ) => void;
  onSubmitAll: () => void;
  isSubmitting?: boolean;
};

export function BulkActionToolbar({
  selectedCount,
  countrySelectItems,
  onBulkApply,
  onSubmitAll,
  isSubmitting = false,
}: BulkActionToolbarProps) {
  if (selectedCount === 0) return null;

  return (
    <div className="flex items-center gap-3">
      <P size="sm" weight="semibold">
        {selectedCount} selected
      </P>
      <BulkApplyPopover
        countrySelectItems={countrySelectItems}
        onApply={onBulkApply}
      />
      <SubmitAllPopover
        selectedCount={selectedCount}
        onConfirm={onSubmitAll}
        isSubmitting={isSubmitting}
      />
    </div>
  );
}
